import { generateTestId } from "@client-shared";
import { InvoiceStatus } from "@shared/types";

export const setFilterBarTestId = (identifier: string): string => generateTestId("FilterBar", identifier);

// Specific element testIds
export const setFilterBarSearchInputTestId = (): string => setFilterBarTestId("search-input");

export const setFilterBarSearchButtonTestId = (): string => setFilterBarTestId("search-button");

export const setFilterBarDateFilterButtonTestId = (): string => setFilterBarTestId("date-filter-button");

export const setFilterBarStatusButtonTestId = (status: InvoiceStatus): string => setFilterBarTestId(`status-${status}`);

export const setFilterBarContainerTestId = (): string => setFilterBarTestId("container");
